import { render, staticRenderFns } from "./orderManager.vue?vue&type=template&id=2ba4e884&scoped=true&"
import script from "./orderManager.vue?vue&type=script&lang=js&"
export * from "./orderManager.vue?vue&type=script&lang=js&"
import style0 from "./orderManager.vue?vue&type=style&index=0&id=2ba4e884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba4e884",
  null
  
)

export default component.exports